const SOCIALMEDIA = [

  {
    id: 1,
    img: require('./icons/github.png'),
    name: "github",
    link: "https://github.com/anvianvi",
  },
  {
    id: 2,
    img: require('./icons/linkedin.png'),
    name: "linkedin",
    link: "https://www.linkedin.com/in/pavel-viarbitsky/",
  },
  {
    id: 3,
    img: require('./icons/codewars.png'),
    name: "codewars",
    link: "https://www.codewars.com/users/anvianvi",
  },
  
];

export { SOCIALMEDIA }